// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"dd61e952","226":"83b6eadb","801":"284e593f"}[chunkId] + ".chunk.js";
};